<template>

    <!-- Header Cart Start -->
    <router-link :to="{name:  'cart_items.index', params: { lang : $i18n.locale  }}" v-if="auth.isLoggedIn()"
                 class="ec-header-btn  me-0">
        <div class="header-icon"><i class="fi-rr-shopping-basket"></i></div>
        <span class="ec-header-count ec-cart-count cart-count-lable">{{ cartItems.length }}</span>
    </router-link>
    <a class="ec-header-btn me-0"  data-bs-toggle="modal" data-bs-target="#loginOrRegister" v-else>
        <div class="header-icon"><i class="fi-rr-shopping-basket"></i></div>
        <span class="ec-header-count ec-cart-count cart-count-lable">{{ cartItems.length }}</span>
    </a>


    <!-- Header Cart End -->

<!--    <li class="right-side" >-->
<!--        <div class="onhover-dropdown header-badge">-->

<!--            <router-link :to="{name: ! auth.isLoggedIn() ? 'login' :'cart_items.index', params: { lang : $i18n.locale  }}"-->
<!--                         class="btn p-0 position-relative header-wishlist">-->

<!--                 <i data-feather="gift"></i>-->
<!--                <span class="position-absolute top-0 start-100 translate-middle badge">-->
<!--                    {{ cartItems.length }}-->
<!--                    <span class="visually-hidden">The number of cart items</span>-->
<!--                </span>-->
<!--            </router-link>-->

<!--            <div class="onhover-div" v-if="cartItems?.length > 0">-->
<!--                <ul class="cart-list">-->
<!--                    <li class="product-box-contain w-100" v-for="product in cartItems" :key="product.id">-->
<!--                        <div class="drop-cart">-->
<!--                            <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"-->
<!--                                         class="drop-image">-->

<!--                                <img :src="product.image ?? '/images/spices-jar.jpeg'" class="blur-up lazyload" :alt="product.name">-->
<!--                            </router-link>-->
<!--                            <div class="drop-contain">-->
<!--                                <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">-->
<!--                                    <h5>{{ product.name }}</h5>-->
<!--                                </router-link>-->
<!--                                <h6><span>{{ product?.cart?.quantity }} x</span>  {{ product.price }} {{ $t('SAR') }}</h6>-->
<!--                                <button class="close-button close_button" @click="removeFromCart(product)">-->
<!--                                    <i class="fa-solid fa-xmark"></i>-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </li>-->
<!--                </ul>-->
<!--                <div class="price-box">-->
<!--                    <h5> {{ $t('Subtotal') }} :  </h5>-->
<!--                    <h4 class="theme-color fw-bold">{{ subtotal }} {{ $t('SAR') }}</h4>-->
<!--                </div>-->
<!--                <div class="button-group d-flex align-items-end">-->

<!--                    <router-link :to="{name: 'cart_items.index', params: { lang : $i18n.locale  }}"-->
<!--                                 class="btn btn-sm cart-button"> {{ $t('View Cart') }}</router-link>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--    </li>-->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    inject: ['auth'],
    computed: {
        ...mapGetters(['cartItems']), // Map the cartItems getter
        subtotal() {
            return parseFloat(
                this.cartItems.reduce((subtotal, product) => subtotal + (product?.cart?.quantity || 0) * product.price, 0)
            ).toFixed(2);
        },
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart']), // Map the addToCart and removeFromCart actions
        // Your other methods here
    },
};

</script>

<style scoped>
/* Add your component-specific styles here */
</style>
